import { createRoot } from 'react-dom/client'
import './styles.css'
import { Logo } from '@pmndrs/branding'
import { App } from './App'

/*
Model JSX auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.2.3 model.glb --transform --simplify --resolution=2048
Author: Omar Faruq Tawsif (https://sketchfab.com/omarfaruqtawsif32)
License: CC-BY-4.0 (http://creativecommons.org/licenses/by/4.0/)
*/

function Root() {
  return (
    <>
      <App />
      <div style={{ position: 'absolute', pointerEvents: 'none', top: 0, left: 0, width: '100vw', height: '100vh' }}>
        <div className="hide-on-mobile" style={{ position: 'absolute', bottom: 30, left: 30, fontSize: '13px' }}>
          scroll up/down ...
        </div>
        {/* <a href="https://madovertech.io/" style={{ position: 'absolute', bottom: 30, left: 90, fontSize: '13px' }}>
          madovertech.io
          <br />
          New Media Technology
        </a> */}
        <div className="hide-on-mobile" style={{ position: 'absolute', bottom: 30, right: 30, fontSize: '13px', display: "flex", flexDirection: "column", alignItems: "flex-end", pointerEvents: 'auto'}}>
          <div href="tel:+919711699861">+91-9711699861</div>
          <div href="mailto:hello@madovertech.io">hello@madovertech.io</div>
          <a href="https://www.instagram.com/madovertechnology" target="_blank" rel="noopener noreferrer" style={{ color: '#1a1a1a', textDecoration: 'none', marginTop: '0rem' }}>@madovertechnology</a>
        </div>
        {/* <Logo style={{ position: 'absolute', bottom: 30, left: 30, width: 30 }} /> */}
        <a href="/" style={{ position: 'absolute', top: 30, left: 30, fontSize: '13px', pointerEvents: 'auto', color: '#1a1a1a', zIndex: 1000, textDecoration: 'none' }}>
          <b>Interactive Tech Solutions</b>
          <br/>
          for Events & Exhibitions
        </a>
        <a style={{ position: 'absolute', top: 30, right: 30, fontSize: '13px', zIndex: 1000, pointerEvents: 'auto', textDecoration: 'none', color: '#1a1a1a', fontWeight: 500 }} href="https://wa.me/919711699861?text=Hi%2C%20I%27m%20interested%20in%20learning%20more%20about%20your%20interactive%20tech%20solutions" target="_blank" rel="noopener noreferrer">
          {"Let's Tech →"}
        </a>
      </div>{' '}
    </>
  )
}

createRoot(document.getElementById('root')).render(<Root />)
